const normalizeBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

// Amposter now uses the Spring Boot API as its only application data source.
// This compatibility export remains temporarily while Firebase branches are
// removed from individual screens; it is deliberately not configurable.
export const USE_BACKEND = true;
export const API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_API_BASE_URL || 'https://api.amposter.com'
);

export const assertRuntimeConfiguration = () => {
  if (!/^https?:\/\//i.test(API_BASE_URL)) {
    throw new Error('REACT_APP_API_BASE_URL must be an absolute HTTP(S) URL');
  }
};
